import React from 'react';
import shortid from 'shortid';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';

import { getFooterLinkProps } from './Footer.helpers';
import {
  linkContainer,
  iconContainer,
  footerCol,
} from './scss/Footer.module.scss';

const FooterLinksBlock = ({ links }) => (
  <Col sm="6" lg="4">
    <div className={footerCol}>
      {links.map(link => {
        const { tag: Tag, ...linkProps } = getFooterLinkProps(link);
        return (
          <div key={shortid()} className={linkContainer}>
            {link.icon && (
              <div className={iconContainer}>
                <img src={link.icon} alt={link.value} />
              </div>
            )}
            <div>
              <Tag {...linkProps}>{link.value}</Tag>
            </div>
          </div>
        );
      })}
    </div>
  </Col>
);

FooterLinksBlock.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
};

export default FooterLinksBlock;
